import React, { ReactNode } from 'react';
import cursor from '../../img/event/cursor.svg';

export const DoubleLineButton = ({
  children,
  onClick,
  borderColor = 'border-[#2b492a]',
  bgColor = 'bg-black',
  hoverBgColor = 'hover:bg-black/50',
  textColor = 'text-white',
}: {
  children: ReactNode;
  onClick: () => void;
  borderColor?: string;
  bgColor?: string;
  hoverBgColor?: string;
  textColor?: string;
}) => {
  return (
    <div
      className={`cursor-pointer rounded-[24px] border-[2px] ${borderColor} p-1 sm:rounded-[41px] sm:border-[3px] sm:p-[7px]`}
      style={{ boxShadow: '0px 4px 4px 0px rgba(0,0,0,0.25)' }}
      onClick={onClick}
    >
      <div
        className={`rounded-[17px] ${bgColor} text-center ${textColor} ${hoverBgColor} sm:rounded-[30px]`}
      >
        {children}
      </div>
    </div>
  );
};

export const DoubleLineWithCursorButton = ({
  children,
  onClick,
  borderColor = 'border-white/70',
  bgColor = 'bg-[#ffb218]',
  hoverBgColor = 'hover:bg-[#e6a016]',
  textColor = 'text-black',
}: {
  children: ReactNode;
  onClick: () => void;
  borderColor?: string;
  bgColor?: string;
  hoverBgColor?: string;
  textColor?: string;
}) => (
  <div
    className={`relative cursor-pointer rounded-[24px] border-[2px] ${borderColor} p-1 sm:rounded-[41px] sm:border-[3px] sm:p-[7px]`}
    style={{ boxShadow: '0px 4px 4px 0px rgba(0,0,0,0.25)' }}
    onClick={onClick}
  >
    <div
      className={`rounded-[17px] border-4 border-white ${bgColor} text-center ${textColor} ${hoverBgColor} sm:rounded-[30px]`} // hover : #ffb218의 90%
    >
      {children}
    </div>
    <div className="absolute right-[5%] top-[65%] h-10 w-10 sm:h-14 sm:w-14">
      <img src={cursor} alt="cursor" className="h-10 w-10 sm:h-14 sm:w-14" />
    </div>
  </div>
);
